import FabricInventoryType from "./actionTypes"

const INIT_STATE = {
  pageData: {
    loading: true,
    data: {}
  },
  detail: {
    loading: false,
    data: {}
  },
  saved: {
    loading: false
  },
  detailPage: {
    loading: true,
    data: []
  }
}

const FabricInventory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FabricInventoryType.GET_FABRIC_INVENTORY_PAGES_SUCCESS:
      return {
        ...state,
        pageData: action.payload,
      }

    case FabricInventoryType.GET_DETAIL_FABRIC_INVENTORY_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      }

    case FabricInventoryType.PUT_FABRIC_INVENTORY_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }
    case FabricInventoryType.GET_FABRIC_INVENTORY_DETAIL_PAGES_SUCCESS:
      return {
        ...state,
        detailPage: { ...state.detailPage, data: [...state.detailPage.data, action.payload] },
      }

    default:
      return state
  }
}

export default FabricInventory
